import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/cookienotice.scss";

const STORAGE_KEY = "uightparcel-cookie-notice";

function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(!window.localStorage.getItem(STORAGE_KEY));
    } catch {
      setVisible(true);
    }

    const reopen = () => setVisible(true);
    window.addEventListener("open-cookie-notice", reopen);
    return () => window.removeEventListener("open-cookie-notice", reopen);
  }, []);

  const dismiss = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "dismissed");
    } catch {
      // The notice can still be dismissed for the current page view.
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside className="cookie-notice" role="dialog" aria-modal="false" aria-labelledby="cookie-title">
      <div>
        <h2 id="cookie-title">Browser storage, plainly explained.</h2>
        <p>We use necessary local storage to remember your selection and whether you dismissed this notice. No advertising or analytics cookies are currently used. <Link to="/cookies" onClick={dismiss}>Read the cookie notice</Link>.</p>
      </div>
      <button type="button" onClick={dismiss}>Got it</button>
    </aside>
  );
}

export default CookieNotice;
